import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaBars } from "react-icons/fa";
import { Nav, NavbarContainer, NavLogo, MobileIcon, NavMenu, NavItem, NavLinks, NavBtnLink, NavBtnAvatar, NavLeft, NavCenter, NavRight, NavNotification } from "./NavbarElements";
import { Dropdown, Button, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpen, faSignOutAlt,faTachometerAlt } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { Toast, ToastContainer } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from "../../Context/AuthContext";
import NotificationDropdown from "../Notifications.js";
import MessagesNotifications from "../Messages.js";
import Location from '../../components/Location';
import { BASE_URL } from "../../constants.js";
 const NavbarComponent = ({ toggle, notifications }) => {
  const { user, setUser, logout } = useAuth(); 
  const [toastMessage, setToastMessage] = useState('');
   const [showToast, setShowToast] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(user?.profilePhoto);
  const [scrollNav, setScrollNav] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation(); 
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const isLoginPage = location.pathname === '/signin';
  const isRegisterPage = location.pathname === '/register';

  useEffect(() => {
    const updatedUser = JSON.parse(localStorage.getItem("userData"));
    setProfilePhoto(updatedUser?.profilePhoto);
  }, [user]);

  useEffect(() => {
    const changeNav = () => {
      if (window.scrollY >= 80) {
        setScrollNav(true);
      } else {
        setScrollNav(false);
      }
    };
  
    window.addEventListener("scroll", changeNav);
  
    const token = localStorage.getItem('token');
    const savedUserData = localStorage.getItem('userData');
  
    if (token && savedUserData) {
      setIsLoggedIn(true);
      setUser(JSON.parse(savedUserData));
    } else {
      setIsLoggedIn(false);
      setUser(null);
    }
  
    setLoading(false); // Set loading to false after fetching user data
  
    return () => window.removeEventListener("scroll", changeNav);
  }, [setUser]);
const handleLogout = async () => {
  const userId = user?.id;

  try {
    await axios.post(`${BASE_URL}/users/logout`, 
      { userId }, 
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );

    // Clear localStorage and state
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    setIsLoggedIn(false);
    setUser(null);
   logout();
  
      setShowToast(true); 
      setTimeout(() => {
        navigate('/'); 
      }, 2000);
  } catch (error) {
    console.error('Error logging out:', error);
  }
};

  return (
<Nav scrollNav={scrollNav} isHomePage={isHomePage}>
  <NavbarContainer>
    <NavLeft>
      <NavLogo to="/">Ordamo</NavLogo>

      <MobileIcon onClick={toggle}>
        <FaBars />
      </MobileIcon>
    </NavLeft>
    <NavRight>
     
      {isLoggedIn && user && (
        <NavNotification>
          <NotificationDropdown notifications={notifications} />
          <MessagesNotifications notifications={notifications} />
          <Location />
        </NavNotification>
      )}

      <NavMenu>
        {/* Right Section - Avatar & Notifications */}
        <NavBtnAvatar>
          {loading ? (
            <div className="text-center mb-3">
              {/* Loading spinner or placeholder */}
            </div>
          ) : isLoggedIn && user ? (
           <Dropdown align="end">
            <Dropdown.Toggle
              as={Button}
              variant="outline-primary"
              className="p-0"
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
              }}
            >
              <div className="media d-flex align-items-center">
                {user.profilePhoto ? (
                  <img
                    src={user.profilePhoto}
                    alt="Profile"
                    className="rounded-circle"
                    width="30"
                    height="30"
                  />
                ) : (
                  <div
                    className="rounded-circle bg-gray-600 d-flex justify-content-center align-items-center"
                    style={{
                      width: 30,
                      height: 30,
                      color: "white",
                      fontWeight: "bold",
                      fontSize: 14,
                    }}
                  >
                    {user?.firstName?.charAt(0).toUpperCase() || "U"}
                  </div>
                )}
              </div>
            </Dropdown.Toggle>
          
            <Dropdown.Menu
              className="p-2"
              style={{
                width: "100%",
                minWidth: "250px",
                maxWidth: "90vw", // responsive max width
              }}
            >
              <div className="d-flex align-items-center mb-2">
                {user.profilePhoto ? (
                  <img
                    src={user.profilePhoto}
                    alt="Profile"
                    className="rounded-circle"
                    width="30"
                    height="30"
                  />
                ) : (
                  <div
                    className="rounded-circle bg-gray-600 d-flex justify-content-center align-items-center"
                    style={{
                      width: 30,
                      height: 30,
                      color: "white",
                      fontWeight: "bold",
                      fontSize: 14,
                    }}
                  >
                    {user?.firstName?.charAt(0).toUpperCase() || "U"}
                  </div>
                )}
                <div className="ms-3 overflow-hidden">
                <div className="fw-bold text-dark text-truncate">
                  {user?.firstName || "Username"} {user?.lastName}
                 </div>
                  <div className="text-muted small text-truncate" style={{ maxWidth: 180 }}>
                    {user?.email || "user@example.com"}
                  </div>
                </div>
              </div>
          
              <Dropdown.Divider />
              <Dropdown.Item href="/profile" className="fw-bold">
                <FontAwesomeIcon icon={faUserCircle} className="me-2" /> My Profile
              </Dropdown.Item>
              <Dropdown.Item href="/chat" className="fw-bold">
                <FontAwesomeIcon icon={faEnvelopeOpen} className="me-2" /> Messages
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item className="fw-bold" onClick={handleLogout}>
                <FontAwesomeIcon
                  icon={faSignOutAlt}
                  className="text-danger me-2"
                />{" "}
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          ) : !isLoginPage && (
            <NavBtnLink to="/signin">Sign In</NavBtnLink>
          )}
        </NavBtnAvatar>
      </NavMenu>
    </NavRight>
  </NavbarContainer>

 <ToastContainer position="top-end" className="p-3">
          <Toast show={showToast} onClose={() => setShowToast(false)} delay={2000} autohide bg="success">
            <Toast.Body className="text-white">Successfully logged out!</Toast.Body>
          </Toast>
        </ToastContainer>

           
</Nav>




  );
};
export default NavbarComponent;